<template>
	<div>
    <h5>{{ $t('Datos personales') }}</h5><br>
    <form method="post" v-on:submit.prevent="onSubmit">
      <div class="form-head fix">
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-institution" :title="$t('Nombre de la biblioteca')"></i></div>
            <input type="text" class="form-control" :placeholder="$t('Nombre de la biblioteca')" maxlength="150" required="" autofocus v-model="biblioteca.nombre" disabled>
        </div>
        <!-- <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-book"></i></div>
            <input type="text" class="form-control" :placeholder="$t('Nombre del catálogo')" maxlength="150" required="" v-model="BibliotecaCatalogo" disabled>
        </div> -->
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-map-marker" :title="$t('Dirección')"></i></div>
            <input type="text" class="form-control" :placeholder="$t('Dirección')" maxlength="150" required="" v-model="biblioteca.direccion" disabled>
        </div>
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-building-o" :title="$t('Población')"></i></div>
            <input type="text" class="form-control" :placeholder="$t('Población')" maxlength="150" required="" v-model="biblioteca.poblacion" disabled>
        </div>
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-building-o" :title="$t('Provincia')"></i></div>
            <input type="text" class="form-control" :placeholder="$t('Provincia')" maxlength="150" required="" v-model="biblioteca.provincia" disabled>
        </div>
        <div class="input-group widthPer50">
          <div class="input-group-addon"><i class="fa fa-envelope-o"></i></div>
            <input type="text" class="form-control" :placeholder="$t('Código postal')" maxlength="150" required="" v-model="biblioteca.codigo_postal" disabled>
        </div>
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-at"></i></div>
            <input type="email" class="form-control" :placeholder="$t('Email / nombre de usuario')" maxlength="150" required="" v-model="biblioteca.email" disabled>
        </div>
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-phone"></i></div>
            <input type="text" class="form-control" :placeholder="$t('Teléfono')" maxlength="150" required="" v-model="biblioteca.telefono" disabled>
        </div>
        <!-- <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-lock"></i></div>
            <input type="password" class="form-control" :placeholder="$t('Contraseña actual')" maxlength="150" required="" v-model="BibliotecaContrasenaActual">
        </div>       -->       
      </div>

      <!-- <div v-if="loading" class="loading center"><img src="@/assets/img/loading.gif" alt=""></div>

      <div v-if="frm_success" class="frm-success">{{ frm_success_message }}</div>
      <div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>

      <div class="center">
        <button class="btn btn-tata mb40" type="submit" :disabled="loading">{{ $t('Actualizar datos') }} <i class="fa fa-angle-double-right"></i></button>
      </div> -->
    </form>
  </div>
</template>

<i18n>
{
  "es": {
    "Datos personales": "Datos personales",
    "Nombre de la biblioteca": "Nombre de la biblioteca",
    "Nombre del catálogo": "Nombre del catálogo",
    "Población": "Población",
    "Dirección": "Dirección",
    "Provincia": "Provincia",
    "Código postal": "Código postal",
    "Email / nombre de usuario": "Email / nombre de usuario",
    "Teléfono": "Teléfono",
    "Contraseña actual": "Contraseña actual",
    "Actualizar datos": "Actualizar datos"
  },
  "en": {

  },
  "ca": {
    "Datos personales": "Dades personals",
    "Nombre de la biblioteca": "Nom de la biblioteca",
    "Nombre del catálogo": "Nom del catàleg",
    "Población": "Població",
    "Dirección": "Direcció",
    "Provincia": "Província",
    "Código postal": "Codi postal",
    "Email / nombre de usuario": "Email / nom d'usuari",
    "Teléfono": "Telèfono",
    "Contraseña actual": "Contrasenya actual",
    "Actualizar datos": "Actualitzar dades"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';

	export default {
		data: () => {
			return{
        biblioteca: [],
        frm_response: '',
        frm_success: false,
        frm_success_message: '',
        frm_error: false,
        frm_error_message: '',
        loading: false
			}
		},
    created(){
      this.getPerfil();
    },
    computed: {
      ...mapGetters(['getApiUrl', 'getLocale'])
    },
    methods: { 
      getPerfil(){
        this.showLoading();
        axios.get(this.getApiUrl + this.getLocale + '/miperfil')
        .then( (respuesta) =>{   
            this.biblioteca = respuesta.data.data;
            this.hideLoading(); 
          })  
          .catch( (error) =>{ 
            this.error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.error = true;
            this.hideLoading();      
          }) 
      },
      validateEmail(){
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(this.biblioteca.email);
      },
      /*onSubmit(){
        if( !this.validateEmail() ){
          this.frm_error_message = this.$t('Formato de email incorrecto');
          this.frm_error = true;
        }else{

          this.frm_success = false;
          this.frm_error = false;
          this.showLoading();

          axios.get('es/miperfil', {
            // IDIOMA
            // CAMBIAR GET POR POST !!!!
            BibliotecaNombre:       this.BibliotecaNombre,
            BibliotecaCatalogo:     this.BibliotecaCatalogo,
            BibliotecaDireccion:    this.BibliotecaDireccion,
            BibliotecaLocalidad:    this.BibliotecaLocalidad,
            BibliotecaCodigoPostal: this.BibliotecaCodigoPostal,
            BibliotecaEmail:        this.BibliotecaEmail,
            BibliotecaContrasena:   this.BibliotecaContrasena
          })
          .then( (response) => {

            this.hideLoading();
            this.frm_success_message = "Los datos se han actualizado con exito.";
            this.frm_success = true;   
            this.clearFormState();
          })
          .catch( (error) => {
            this.hideLoading();
            this.frm_error_message = error;
            this.frm_error = true;
          });

        }
      },*/
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      clearFormState(){
        setTimeout( () => { 
          this.frm_success_message = "";
          this.frm_error_message = "";
          this.frm_success = false;
          this.frm_error = false;
        }, 3000);
      }
    },
    watch: {
    }
  }
</script>
